
      <!-- FORM  -->

      <form [formGroup]="form" (submit)="onSubmit()" novalidate>

          <!--  FULL FORM  -->

          <div *ngIf="style === 'default'">

              <!--  FORM GROUP LOOP  -->

              <section *ngFor="let uiFormGroup of uiFormGroups; let isLast = last" class="written-content">

                  <!--  FORM GROUP HEADING  -->

                  <h3 *ngIf="uiFormGroup.heading">{{uiFormGroup.heading}}</h3>
                  <p *ngIf="uiFormGroup.description" class="sub-heading">{{uiFormGroup.description}}</p>

                  <!--  END FORM GROUP HEADING  -->

                  <!--  FORM GROUP CONTENT  -->

                  <div class="form-group">

                      <!--  FORM CONTROL LOOP  -->

                      <div *ngFor="let uiFormControl of uiFormGroup.controls" class="row">

                          <!--  FORM CONTROL LABEL  -->

                          <div class="label-container col-sm1-30 col-sm3-8 col-md2-8 col-md3-7 col-lg2-6">

                              <!--  LABEL  -->

                              <label [for]="uiFormControl.id" [class.neg-col]="isInvalid(uiFormGroup, uiFormControl)">{{uiFormControl.label}}</label>

                              <!--  END LABEL  -->

                              <!--  DESCRIPTION  -->

                              <p *ngIf="uiFormControl.description" class="description">
                                  <small>{{ uiFormControl.description }}</small>
                              </p>

                              <!--  END DESCRIPTION  -->

                          </div>

                          <!-- END FORM CONTROL LABEL  -->

                          <!--  FORM CONTROL CONTAINER  -->

                          <div class="control-container col-sm1-30 col-sm3-22 col-md2-19 col-md3-17 col-lg2-14">

                              <!--  CONTROL SELECTOR  -->

                              <ui-control-selector
                                  [form]="form.controls[uiFormGroup.name]"
                                  [uiFormControl]="uiFormControl"
                                  [isInvalid]="isInvalid(uiFormGroup, uiFormControl)"
                                  [invalidReasons]="getInvalidReasons(uiFormGroup, uiFormControl)"
                                  (onEvent)="onChildEvent(uiFormGroup, $event)">
                              </ui-control-selector>

                              <!-- END CONTROL SELECTOR  -->

                              <!--  INFO ICON  -->

                              <i *ngIf="uiFormControl.info" class="far fa-info-circle icon-button pri-hl-col" [uiTooltipText]="uiFormControl.info" [uiTooltipConfig]="{placement: 'left'}"></i>

                              <!-- END INFO ICON  -->

                          </div>

                          <!--  END FORM CONTROL CONTAINER  -->

                      </div>

                      <!--  END FORM CONTROL LOOP  -->

                      <!--  INLINE SUBMIT BUTTON  -->

                      <div *ngIf="showSubmit && inlineSubmit && isLast" class="row">
                          <div class="control-container col-sm1-30 col-sm3-22 col-sm3-offset-8 col-md2-19 col-md2-offset-8 col-md3-17 col-md3-offset-7 col-lg2-14 col-lg2-offset-6">
                              <a class="button" [ngClass]="submitTheme + '-button'" [uiLoading]="submitting" (click)="onSubmit()">{{ submitText }}</a>
                          </div>
                      </div>

                      <!--  END INLINE SUBMIT BUTTON  -->

                  </div>

                  <!--  END FORM GROUP CONTENT  -->

              </section>

              <!--  END FORM GROUP LOOP  -->

              <!--  HIDDEN SUBMIT BUTTON  -->

              <button class="hidden">Submit</button>

              <!-- END HIDDEN SUBMIT BUTTON  -->

              <!--  VISIBLE SUBMIT BUTTON  -->

              <div *ngIf="showSubmit && !inlineSubmit" class="row">
                  <div class="col-sm1-30 align-right">
                      <a class="button" [ngClass]="submitTheme + '-button'" [uiLoading]="submitting" (click)="onSubmit()">{{ submitText }}</a>
                  </div>
              </div>

              <!-- END VISIBLE SUBMIT BUTTON  -->

          </div>

          <!--  END FULL FORM  -->

          <!--  CONTROLS ONLY  -->

          <div *ngIf="style === 'plain'" class="plain">

              <!--  FORM GROUP LOOP  -->

              <div *ngFor="let uiFormGroup of uiFormGroups" class="plain-group-container">

                  <!--  FORM CONTROL LOOP  -->

                  <div *ngFor="let uiFormControl of uiFormGroup.controls" class="plain-control-container">

                      <!--  CONTROL SELECTOR  -->

                      <ui-control-selector
                          [form]="form.controls[uiFormGroup.name]"
                          [uiFormControl]="uiFormControl"
                          [isInvalid]="isInvalid(uiFormGroup, uiFormControl)"
                          [invalidReasons]="getInvalidReasons(uiFormGroup, uiFormControl)"
                          (onEvent)="onChildEvent(uiFormGroup, $event)">
                      </ui-control-selector>

                      <!-- END CONTROL SELECTOR  -->

                  </div>

                  <!--  END FORM CONTROL LOOP  -->

              </div>

              <!--  END FORM GROUP LOOP  -->

              <!--  HIDDEN SUBMIT BUTTON  -->

              <button class="hidden">Submit</button>

              <!-- END HIDDEN SUBMIT BUTTON  -->

          </div>

          <!--  END CONTROLS ONLY  -->

      </form>

      <!--  END FORM  -->
    